import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearUserTokens, setUserTokens } from '@utils/userUtils';

import { IUserMeta, LoadUserSuccessAction, LoginSuccessAction } from './types';

const initialState: IUserMeta = {
  isAuthenticated: false,
  info: {
    id: '',
    firstName: '',
    lastName: '',
    access: '',
    businessUser_Id: '',
    businessUser_Code: '',
    email: '',
    agentType: '',
    businessUser_AllowGroupPolicy: false,
    businessUser_AllowPolicyCorrection: false,
    businessUser_AllowPolicyCorrectionAfterClosing: false,
    businessUser_AllowEndorsementCostEdits: false,
    businessUser_AllowPolicyCancellation: false,
    businessUser_AllowEndorsement: false,
    businessUser_AllowClauseEdits: false,
    businessUser_AllowPlanCoverEdits: false,
    businessUser_AllowTransactionModification: false,
    businessUser_AmendmentIssueDateEditRights: false,
    businessUser_ProductionClosingRights: false,
    businessUser_ReinsuranceClosingRights: false,
    businessUser_PolicyIssueDateEditRights: false,
    businessUser_Access: {
      Code: '',
      Id: '',
      Title: ''
    },
    editableChargesLines: []
  },
  userRoles: [],
  haveWeakPassword: false,
  linesOfBusinessStatuses: {
    Active: false,
    Code: '',
    Title: ''
  },
  updatedUserRoles: []
};

const usersSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    LoginSuccess(state, action: PayloadAction<LoginSuccessAction>) {
      state.isAuthenticated = true;
      const { jwtToken, id_token, refreshTokenObject } = action.payload;
      setUserTokens(jwtToken, id_token, refreshTokenObject);

      return state;
    },
    LoadUserSuccess(state, action: PayloadAction<LoadUserSuccessAction>) {
      state = {
        ...action.payload.user,
        isAuthenticated: true
      };

      return state;
    },
    LogoutUser(state) {
      state = initialState;
      clearUserTokens();

      return state;
    }
  }
});

export const { LoginSuccess, LoadUserSuccess, LogoutUser } = usersSlice.actions;

const userReducer = usersSlice.reducer;
export default userReducer;
